module.exports = __webpack_public_path__ + "img/김한경.1eabeef5.jpg";